import {
  scalePow as $7aJKD$scalePow,
  scaleLinear as $7aJKD$scaleLinear,
  scaleOrdinal as $7aJKD$scaleOrdinal,
  select as $7aJKD$select,
  arc as $7aJKD$arc,
  pie as $7aJKD$pie,
} from 'd3';
import ENV from 'scaleflow/config/environment';
import { apiEndpoint } from '../endpoints';

const $6bf0283bd73b3e87$export$e506a1d27d1eaa20 = {
  initiatives: {
    labels: {
      show: true,
    },
    bubbles: {
      size_field: 'bon_value',
      color_field: 'theme.id',
      values: {
        show: false,
        field: 'bon_investment',
        type: 'number',
        delimiter: 1000,
        prefix: undefined,
        suffix: 'k',
      },
    },
  },
  timelines: {
    show_capacity: false,
  },
  markers: {
    today: true,
    center: true,
  },
  sections: {
    field: 'source',
    color: true,
    number_of_slices: 1000,
  },
};
var $6bf0283bd73b3e87$export$2e2bcd8739ae039 =
  $6bf0283bd73b3e87$export$e506a1d27d1eaa20;

const $8ce3d61709e7dafe$export$9dd6ff9ea0189349 = {
  size: 900,
  margin: 40,
  padding: 70,
  timelines: {
    color: '#D1D5DB',
    width: 1,
    labels: {
      font_size: '15px',
      padding: 15,
      border: {
        width: '1px',
        color: '#6B7280',
        highlight_color: '#D97706',
      },
    },
    capacity_icon: '\uD83D\uDD50',
  },
  sections: {
    border: {
      color: '#7C3AED',
      width: 1,
    },
    labels: {
      font_size: '22px',
    },
  },
  axis: {
    color: '#7C3AED',
  },
  bubbles: {
    min_size: 7,
    max_size: 15,
  },
  initiatives: {
    labels: {
      font_size: 18,
    },
  },
  markers: {
    labels: {
      font_size: '14px',
      padding: 12,
      border: {
        width: '1px',
        color: '#6B7280',
        highlight_color: '#D97706',
      },
    },
  },
  color_range: [
    '#2563EB',
    '#D97706',
    '#059669',
    '#4F46E5',
    '#7C3AED',
    '#DB2777',
  ],
  inner_circle_diameter: 80,
};
var $8ce3d61709e7dafe$export$2e2bcd8739ae039 =
  $8ce3d61709e7dafe$export$9dd6ff9ea0189349;

function $fab42eb3dee39b5b$export$80be079cb759cea0(date, weeks) {
  const one_week = 604800000;
  const new_date = new Date(date);
  new_date.setTime(date.getTime() + weeks * one_week);
  return new_date;
}
async function $fab42eb3dee39b5b$export$fd24e5aa743a9494(
  token,
  statuses = 'ACTIVE,DISCOVERY,READY FOR PLANNING,READY,DRAFT,COMPLETED',
) {
  if (token === undefined) return [];
  let data = [];
  const response = await fetch(
    `${apiEndpoint()}/initiatives?filter[status]=` + statuses,
    {
      headers: {
        Accept: 'application/vnd.api+json',
        Authorization: token,
      },
      method: 'GET',
    },
  );
  if (response.ok) {
    const json_data = await response.json();
    data = json_data.data.map((i) => {
      return {
        ...i.attributes,
        id: i.id,
      };
    });
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      if (element.starting_week_from != undefined)
        data[index].start_date = $fab42eb3dee39b5b$export$88a7113263f96c05(
          element.starting_week_from,
        );
    }
    for (let index = 0; index < json_data.data.length; index++) {
      const element = json_data.data[index];
      data[index].theme = {
        id: element.relationships.theme?.data?.id,
      };
    }
  }
  return data;
}
async function $fab42eb3dee39b5b$export$e63bf5f3a4b0ad0(token) {
  if (token === undefined) return [];
  let data = [];
  const response = await fetch(`${apiEndpoint()}/themes`, {
    headers: {
      Accept: 'application/vnd.api+json',
      Authorization: token,
    },
    method: 'GET',
  });
  if (response.ok) {
    const json_data = await response.json();
    data = json_data.data.map((i) => {
      return {
        ...i.attributes,
        id: i.id,
      };
    });
  }
  return data;
}
function $fab42eb3dee39b5b$export$88a7113263f96c05(dateString) {
  const [year, week] = dateString.split('-');
  const date = new Date(+year, 0, 1 + (+week - 1) * 7);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}`;
  return formattedDate;
}
function $fab42eb3dee39b5b$export$a8dcec409edaeef(css_class) {
  const color_map = {
    'bg-gray-600': '#4B5563',
    'bg-blue-600': '#2563EB',
    'bg-yellow-600': '#D97706',
    'bg-orange-600': '#ea580c',
    'bg-green-600': '#059669',
    'bg-purple-600': '#7C3AED',
    'bg-red-600': '#dc2626',
    'bg-pink-600': '#db2777',
  };
  return color_map[css_class];
}
function $fab42eb3dee39b5b$export$7460e682ce0f6da3(degrees) {
  return ((degrees - 90) * Math.PI) / 180;
}
function $fab42eb3dee39b5b$export$575567690b0feb0d(rad) {
  return (rad * 180) / Math.PI - 90;
}
async function $fab42eb3dee39b5b$export$354d673d2de74a14(
  s,
  number_of_slices = 100,
) {
  const encoder = new TextEncoder();
  const data = encoder.encode(s);
  const hash = await window.crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hash)); // convert buffer to byte array
  const hashNum = hashArray.reduce((a, b) => a + b, 0); // convert byte array to a number
  return hashNum % (number_of_slices + 1);
}
function $fab42eb3dee39b5b$export$3da0c1ee5c83c1d7(s) {
  return s.indexOf('.') > 0;
}
function $fab42eb3dee39b5b$export$1dc1e50544972cf2(obj, nested_field) {
  if (typeof obj.get !== 'undefined') return obj.get(nested_field);
  else {
    const [outer, inner] = nested_field.split('.');
    return obj[outer]?.[inner];
  }
}
function $fab42eb3dee39b5b$export$f87898330e677cb5(
  starting_week,
) /*yyyy-WW:yyyy-WW*/ {
  const week_string = starting_week.split(':')[0];
  const regex = /^(\d{4})-([0-5][0-9])$/;
  const match = regex.exec(week_string);
  if (match) {
    const year = parseInt(match[1], 10);
    const week = parseInt(match[2], 10);
    const date = new Date(year, 0, 1 + (week - 1) * 7);
    const day = date.getDay();
    date.setDate(date.getDate() - day + (day === 0 ? 7 : 0));
    return date;
  }
  return null;
}

const $2f416dba7774550a$export$7608f99c51d98df2 =
  (0, $6bf0283bd73b3e87$export$e506a1d27d1eaa20);
const $2f416dba7774550a$export$172a5934950afa00 =
  (0, $8ce3d61709e7dafe$export$9dd6ff9ea0189349);
class $2f416dba7774550a$export$bace472c466fdd25 {
  options = $2f416dba7774550a$export$7608f99c51d98df2;
  invalid_initiatives = [];
  /**
   * Create a RADAR within an HTML element.
   *
   * @param element string HTML Element indicator where the radar should load. Example: '#radar'
   * @param data RadarData An object contain the dynamic data for the radar
   * @param options RadarOptions An object containing the options and feature flags for the radar
   * @param styles  RadarStyles An object containing style elements of the radar.
   *
   * @remark In order to actually render the radar you have to call the `generate()` function.
   */ constructor(
    element,
    data,
    options = $2f416dba7774550a$export$7608f99c51d98df2,
    styles = $2f416dba7774550a$export$172a5934950afa00,
  ) {
    this.options = options;
    this.styles = styles;
    this.data = data;
    this.element = element;
  }
  /**
   * Actually Generate the visuals for the radar.
   */ async generate() {
    this.data.initiatives = await this.data.initiatives;
    // Take care of unrenderable initiatives
    this.sanitize_initiatives();
    const [valid, invalid] = this.filter_unrenderable_initiatives(
      this.data,
      this.options,
    );
    this.data.initiatives = valid;
    this.invalid_initiatives = invalid;
    if (this.data.initiatives.length > 0) {
      // If the oldest initiative is older than the oldest timeline, add the date of that initiative as as timeline.
      this.data.timelines.sort((a, b) => a.date.getTime() - b.date.getTime());
      this.data.initiatives.sort(
        (a, b) =>
          new Date(a.start_date).getTime() - new Date(b.start_date).getTime(),
      );
      if (
        this.data.timelines[0].date.getTime() >
        new Date(this.data.initiatives[0].start_date).getTime()
      ) {
        const date = new Date(this.data.initiatives[0].start_date);
        const date_options = {
          weekday: undefined,
          year: '2-digit',
          month: 'short',
          day: undefined,
        };
        this.data.timelines.unshift({
          label: date.toLocaleDateString(undefined, date_options),
          date: date,
        });
      }
    }
    // Make sure we're dealing with dates and not strings
    this.convert_strings_to_dates();
    // Setup the default marker(s)
    if (this.data.markers == undefined) this.data.markers = [];
    if (this.options.markers.center == true) {
      const date_options = {
        weekday: undefined,
        year: '2-digit',
        month: 'short',
        day: undefined,
      };
      this.data.timelines[0].label =
        this.data.timelines[0].date.toLocaleDateString(undefined, date_options);
    }
    // Prep work for setting up the timescale
    const scale_start =
      (0, $8ce3d61709e7dafe$export$9dd6ff9ea0189349).inner_circle_diameter / 2;
    const scale_end =
      this.styles.size / 2 - this.styles.margin - this.styles.padding;
    this.timescale = $7aJKD$scalePow()
      .exponent(0.7)
      .domain([
        this.data.timelines[0].date.getTime(),
        this.data.timelines.at(-1).date.getTime(),
      ])
      .range([scale_start, scale_end])
      .clamp(false);
    this.bubble_scale = $7aJKD$scaleLinear()
      .domain(this.bubble_domain())
      .range([this.styles.bubbles.min_size, this.styles.bubbles.max_size])
      .clamp(true);
    this.color_scale = $7aJKD$scaleOrdinal()
      .domain(this.color_domain())
      .range(this.color_range())
      .unknown('#1F2937');
    this.svgOuter = $7aJKD$select(this.element);
    this.viewbox = {
      width: this.styles.size,
      height: this.styles.size,
      x: this.styles.size * -0.5,
      y: this.styles.size * -0.5,
    };
    this.svgOuter.attr(
      'viewBox',
      '0 0 ' + this.viewbox.width + ' ' + this.viewbox.height,
    );
    this.svg = this.svgOuter.append('g').attr('class', 'radar');
    this.layers = {
      sections: this.svg.append('g').attr('class', 'sections'),
      timelines: this.svg.append('g').attr('class', 'timeline'),
      today: this.svg.append('g').attr('class', 'today'),
      dots: this.svg.append('g').attr('class', 'initiatives'),
      markers: this.svg.append('g').attr('class', 'markers'),
      axis: this.svg.append('g').attr('class', 'timeline'),
      labels: this.svg.append('g').attr('class', 'labels'),
    };
    this.outerRadius =
      this.styles.size / 2 - this.styles.margin - this.styles.padding;
    this.innerRadius = this.timescale(this.data.timelines[0].date.getTime());
    this.weights = this.data.sections.map((d) => d.weight);
    this.arc_generator = $7aJKD$arc()
      .innerRadius(this.innerRadius)
      .outerRadius(this.outerRadius);
    this.padAngle = 0.03;
    this.pie = $7aJKD$pie()
      .padAngle(this.padAngle)
      .value((d) => d.weight);
    this.max = Math.max(...this.weights);
    this.total = this.weights.reduce((prev, cur) => (prev += cur), 0);
    this.rotation = 360 * (this.max / this.total / 2) * -1 + 1;
    this.label = new $2f416dba7774550a$var$LabelTransformer(
      this.styles,
      this.rotation,
    );
    let color_map;
    if (this.data.color_map != undefined) {
      const data_map = await this.data.color_map;
      const map = new Map(Object.entries(data_map));
      color_map = (key) => map.get(key);
    } else color_map = this.color_scale;
    this.initiative = new $2f416dba7774550a$var$InitiativeTransformer(
      this.options,
      this.timescale,
      this.bubble_scale,
      color_map,
      this.data.sections,
      this.pie,
      this.rotation,
    );
    /**
     * BEWARE: The order of these commands determines the order of the visual layers.
     * Things that generated FIRST are at the BOTTOM of the visual stack.
     */ this.generate_sections();
    this.generate_initiatives();
    this.generate_initiative_labels();
    this.generate_timelines();
    this.generate_axis();
    this.generate_markers(this.layers.markers, this.data.markers);
    if (this.options.markers.today !== false) {
      const today = {
        label: 'Today',
        date: new Date(),
        today: true,
      };
      this.generate_markers(this.layers.today, [today], true);
    }
    this.svg.attr(
      'transform',
      `translate(${this.styles.size / 2}, ${this.styles.size / 2})`,
    );
  }
  bubble_domain() {
    const values = this.data.initiatives
      .map(
        (initiative) => initiative[this.options.initiatives.bubbles.size_field],
      )
      .filter((value) => value != undefined);
    let range;
    if (values.length > 0) range = [Math.min(...values), Math.max(...values)];
    else range = [0, 100];
    return range;
  }
  color_domain() {
    const values = this.data.initiatives
      .map(
        (initiative) =>
          initiative[this.options.initiatives.bubbles.color_field],
      )
      .filter((value) => value != undefined)
      .sort();
    return values;
  }
  color_range() {
    return this.styles.color_range;
  }
  sanitize_initiatives() {
    this.data.initiatives.forEach((initiative) => {
      initiative = this.sanitize_initiative(initiative);
      // This is where we influence the position of initiatives that are unplanned.
      if (initiative.start_date == undefined)
        initiative.start_date =
          this.data.timelines.at(-1).date.getTime() +
          (this.data.timelines.at(-1).date.getTime() -
            this.data.timelines.at(-2).date.getTime()) /
            2;
    });
  }
  sanitize_initiative(initiative) {
    if (
      initiative.start_date == undefined &&
      initiative.starting_week != undefined
    )
      initiative.start_date = (0, $fab42eb3dee39b5b$export$f87898330e677cb5)(
        initiative.starting_week,
      );
    return initiative;
  }
  /**
   * Split the initiatives in 2 groups. Initiatives that we can safely render on the radar, and those that we can't
   *
   * @param data
   * @param options
   * @returns
   */ filter_unrenderable_initiatives(data, options) {
    let valid = [];
    let invalid = [];
    const sections = this.data.sections.map((section) => {
      return section.id;
    });
    this.data.initiatives.forEach((initiative) => {
      if (
        initiative.start_date != undefined &&
        sections.indexOf(initiative[this.options.sections.field]) > -1
      )
        valid.push(initiative);
      else invalid.push(initiative);
    });
    return [valid, invalid];
  }
  convert_strings_to_dates() {
    for (let index = 0; index < this.data.initiatives.length; index++)
      if (this.data.initiatives[index].start_date !== undefined)
        this.data.initiatives[index].start_date = new Date(
          this.data.initiatives[index].start_date,
        ).getTime();
      else
        console.log(
          'Start Date undefined for: ',
          this.data.initiatives[index].title,
        );
  }
  /**
   * Generate the Circles
   */ generate_timelines() {
    const timescales = this.data.timelines.map((timeline) =>
      timeline.date.getTime(),
    );
    this.layers.timelines
      .selectAll('circle')
      .data(timescales)
      .join('circle')
      .attr('stroke', this.styles.timelines.color)
      .attr('stroke-width', this.styles.timelines.width)
      .attr('fill', 'transparent')
      .attr('r', (d, {}) => this.timescale(d));
    return this.layers.timelines.node();
  }
  generate_markers(layer, markers, highlighted = false) {
    const g = layer;
    g.selectAll('circle')
      .data(markers)
      .join('circle')
      .attr('stroke', highlighted ? '#D97706' : this.styles.timelines.color)
      .attr('stroke-width', '1px')
      .attr('stroke-dasharray', [12, 12])
      .attr('fill', 'transparent')
      .attr('r', (d, {}) => this.timescale(d.date.getTime()));
    const measure = g.append('g');
    const draw = g.append('g');
    const labels = (selection) => {
      selection
        .selectAll('text')
        .data(markers)
        .join('text')
        .text((d) => d.label)
        .attr('y', (d, i, nodes) => {
          return (
            this.timescale(d.date.getTime()) + 0.3 * nodes[i].getBBox().height
          );
        })
        .attr('x', 0)
        .attr('fill', highlighted ? '#D97706' : '#6B7280')
        .attr('text-anchor', 'middle')
        .attr('font-family', 'Inter, Arial')
        .attr('font-size', this.styles.markers.labels.font_size);
    };
    const update_bbox = (selection) => {
      selection
        .selectAll('text')
        .data(markers)
        .each(function (d, i, nodes) {
          d.bbox = nodes[i].getBBox();
        });
    };
    const draw_rect = (selection) => {
      const padding = this.styles.markers.labels.padding;
      selection
        .selectAll('rect')
        .data(markers)
        .join('rect')
        .attr('x', (d) => d.bbox?.x - padding)
        .attr('y', (d) => d.bbox?.y - padding / 2)
        .attr('rx', '8px')
        .attr('ry', '8px')
        .attr('width', (d) => d.bbox?.width + 2 * padding)
        .attr('height', (d) => d.bbox?.height + padding)
        .attr(
          'stroke',
          highlighted
            ? this.styles.markers.labels.border.highlight_color
            : this.styles.markers.labels.border.color,
        )
        .attr('opacity', highlighted ? '100%' : '80%')
        .attr('fill', '#FFF')
        .attr('stroke-width', this.styles.markers.labels.border.width);
    };
    labels(measure);
    update_bbox(measure);
    draw_rect(draw);
    labels(draw);
    return this.layers.markers.node();
  }
  /**
   * Generate Sections
   *
   * @param domain - Domain object
   * @param number_of_sections - the number of sections
   *
   * @internalRemarks
   * https://observablehq.com/@d3/arc-pad-angle
   */ generate_sections() {
    const background = this.layers.sections;
    const g = background.selectAll('g').data(this.pie(this.weights)).join('g');
    g.append('g')
      .selectAll('path')
      .data(this.pie(this.data.sections))
      .join('path')
      .attr('fill', (d, i) =>
        this.options.sections?.color == true ? d.data.color : 'transparent',
      )
      .attr('d', this.arc_generator.padAngle(this.padAngle));
    g.selectAll('line')
      .data(this.pie(this.data.sections))
      .join('line')
      .attr('stroke', this.styles.sections.border.color)
      .attr('stroke-dasharray', [3, 3])
      .attr('stroke-width', this.styles.sections.border.width)
      .attr('x1', 0)
      .attr('y1', 0)
      .attr(
        'x2',
        (d, i) =>
          Math.cos(d.startAngle - Math.PI / 2) *
          (this.styles.size / 2 - this.styles.margin / 2 - this.styles.padding),
      )
      .attr(
        'y2',
        (d, i) =>
          Math.sin(d.startAngle - Math.PI / 2) *
          (this.styles.size / 2 - this.styles.margin / 2 - this.styles.padding),
      );
    g.selectAll('text')
      .data(this.pie(this.data.sections))
      .join('text')
      .text((d, {}) => {
        var title = d.data.name;
        if (
          d.data.weight != undefined &&
          this.options.sections.show_weights != false
        )
          title += ' (' + d.data.weight + '%)';
        return title;
      })
      .attr('transform', this.label.transform)
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Inter, Arial')
      .attr('font-size', this.styles.sections.labels.font_size ?? '22px')
      .attr('font-weight', 'bold')
      .attr('x', this.label.x)
      .attr('y', this.label.y);
    background.attr('transform', `rotate(${this.rotation})`);
    return background.node();
  }
  generate_axis() {
    const g = this.layers.axis;
    const measure = g.append('g');
    const draw = g.append('g');
    const labels = (selection) => {
      selection
        .selectAll('text')
        .data(this.data.timelines)
        .join('text')
        .text((d) => {
          let label = d.label;
          if (this.options.timelines?.show_capacity == true)
            label =
              label +
              ' ' +
              (this.styles.timelines?.capacity_icon ?? '\uD83D\uDD50') +
              ' ' +
              d.capacity;
          return label;
        })
        .attr('y', (d, i, nodes) => {
          return (
            -1 * this.timescale(d.date.getTime()) +
            0.3 * nodes[i].getBBox().height
          );
        })
        .attr('x', 0)
        .attr('text-anchor', 'middle')
        .attr('font-family', 'Inter, Arial')
        .attr('font-size', this.styles.timelines.labels.font_size);
    };
    const update_bbox = (selection) => {
      selection
        .selectAll('text')
        .data(this.data.timelines)
        .each(function (d, i, nodes) {
          d.bbox = nodes[i].getBBox();
        });
    };
    const draw_rect = (selection) => {
      const padding = this.styles.timelines.labels.padding;
      selection
        .selectAll('rect')
        .data(this.data.timelines)
        .join('rect')
        .attr('x', (d) => d.bbox?.x - padding)
        .attr('y', (d) => d.bbox?.y - padding / 2)
        .attr('rx', '8px')
        .attr('ry', '8px')
        .attr('width', (d) => d.bbox?.width + 2 * padding)
        .attr('height', (d) => d.bbox?.height + padding)
        .attr('stroke', '#60EBD4')
        .attr('stroke-width', this.styles.markers.labels.border.width)
        .attr('fill', '#FFF')
        .attr('opacity', '70%');
    };
    labels(measure);
    update_bbox(measure);
    draw_rect(draw);
    labels(draw);
  }
  /**
   * Place the dots on the radar
   */ async generate_initiatives() {
    const g = this.layers.dots;
    const tooltip = $7aJKD$select('body')
      .append('div')
      .style('position', 'absolute')
      .style('z-index', '10')
      .style('visibility', 'hidden')
      .attr(
        'class',
        'text-xs p-2 bg-gray-700 text-white text-center rounded-md ml-3',
      );
    g.selectAll('circle')
      .data(this.data.initiatives)
      .join('circle')
      .attr('cy', this.initiative.cy)
      .attr('r', this.initiative.r)
      .attr('fill', this.initiative.fill)
      .attr('opacity', '90%')
      .attr('transform', (d, i, nodes) => {
        this.initiative
          .transform(d, i)
          .then((val) => nodes[i].setAttribute('transform', val));
      })
      .on('click', ({}, initiative) => {
        this.options.initiatives.onClick(initiative);
      })
      .on('mouseover', ({}, initiative) => {
        tooltip.text(initiative.title);
        return tooltip.style('visibility', 'visible');
      })
      .on('mousemove', function (event) {
        return tooltip
          .style('top', event.pageY - 10 + 'px')
          .style('left', event.pageX + 10 + 'px');
      })
      .on('mouseout', function () {
        return tooltip.style('visibility', 'hidden');
      });
    g.selectAll('text')
      .data(this.data.initiatives)
      .join('text')
      .text((d) => {
        if (this.options.initiatives.bubbles?.values.show == false) return '';
        const type = this.options.initiatives.bubbles?.values.type ?? 'string';
        const field = this.options.initiatives.bubbles?.values.field ?? 'title';
        const delimiter =
          this.options.initiatives.bubbles?.values.delimiter ?? 1000;
        let value = '';
        if (type == 'string') value = d[field].at(0, 2).toUpperCase();
        else {
          let value = Math.round(d[field] / delimiter);
          if (isNaN(value)) value = '-';
        }
        const options = this.options.initiatives.bubbles.values;
        value = (options.prefix ?? '') + value + (options.suffix ?? '');
        return value;
      }) /**
       * TODO: This code is left here since it was used to generate a white background behind the initaitve labels
       * This stopped working when we moved to Async data loading. We have to fix it. Keeping the code around to
       * easily get back to it once we figure out how to re-render properly .
       */ // .attr("y", (d: Initiative, i:number, nodes: SVGTextElement[]) => {
      //     this.initiative.y(d,i).then( (val) => {
      //         console.log("y", val)
      //         nodes[i].setAttribute("y", val + this.initiative.r(d) * 0.29)
      //     })
      // })
      // .attr("x", (d: Initiative, i:number, nodes: SVGTextElement[]) => {
      //     this.initiative.x(d,i).then( (val) => {
      //         console.log("x", val)
      //         nodes[i].setAttribute("x", val)
      //     })
      // })
      .attr('y', (d, i, nodes) => {
        this.initiative.y(d, i).then((val) => {
          nodes[i].setAttribute('y', val + this.initiative.r(d) * 0.29);
        });
      })
      .attr('x', (d, i, nodes) => {
        this.initiative.x(d, i).then((val) => {
          nodes[i].setAttribute('x', val);
        });
      })
      .attr('text-anchor', 'middle')
      .attr('font-family', 'Roboto Mono, Inter, Arial')
      .attr('font-size', (d, i) => this.initiative.r(d) * 0.8)
      .attr('fill', 'white')
      .on('mouseover', ({}, initiative) => {
        tooltip.text(initiative.title);
        return tooltip.style('visibility', 'visible');
      })
      .on('mousemove', function (event) {
        return tooltip
          .style('top', event.pageY - 10 + 'px')
          .style('left', event.pageX + 10 + 'px');
      })
      .on('mouseout', function () {
        return tooltip.style('visibility', 'hidden');
      })
      .on('click', ({}, initiative) => {
        initiative?.onClick?.();
      });
  }
  /**
   * Generate the labels next to the dots
   */ async generate_initiative_labels() {
    if (this.options.initiatives?.labels.show == false) return;
    const g = this.layers.labels;
    const measure = g.append('g');
    const draw = g.append('g');
    const labels = (selection) => {
      selection
        .selectAll('text')
        .data(this.data.initiatives)
        .join('text')
        .attr('font-size', this.styles.initiatives.labels.font_size + 'px')
        .text((d) => {
          // If initiatives are rendered in the outer ring their titles probably fall out of the canvas,
          // So we rely on mouse-over instead.
          if (this.timescale(d.start_date) > this.timescale.range()[1])
            return '';
          if (d.abbreviation != undefined && d.abbreviation.length > 0)
            return d.abbreviation; //.split(" ")[0]
          else return d.title.split(' ')[0];
        })
        .attr('y', (d, i, nodes) => {
          this.initiative
            .y(d, i)
            .then((val) => nodes[i].setAttribute('y', val + 6));
        })
        .attr('x', (d, i, nodes) => {
          this.initiative.x(d, i).then((circle_x) => {
            const circle_width = this.initiative.r(d);
            let value;
            if (circle_x < 0) {
              const label_width = nodes[i].getBBox().width;
              value =
                circle_x -
                label_width -
                circle_width -
                this.styles.initiatives.labels.font_size;
            } else
              value =
                circle_x +
                circle_width +
                this.styles.initiatives.labels.font_size / 2;
            nodes[i].setAttribute('x', value);
          });
        })
        .attr('font-family', 'Inter, Arial');
    };
    /**
     * TODO: Fix white boxes behind initiative titles
     * Right now they are not working because the location of the texts
     * became an async call.
     */ // const update_bbox = (selection: any) => {
    //     selection.selectAll("text")
    //         .data(this.data.initiatives)
    //         .each(function(d: Initiative, i: number, nodes: SVGTextElement[]) { d.bbox = nodes[i].getBBox() })
    // }
    // const draw_rect = (selection: any) => {
    //     selection.selectAll("rect")
    //         .data(this.data.initiatives)
    //         .join("rect")
    //         .attr("x", (d: Initiative) => d.bbox?.x)
    //         .attr("y", (d: Initiative) => d.bbox?.y)
    //         .attr("width", (d: Initiative) => d.bbox?.width)
    //         .attr("height", (d: Initiative) => d.bbox?.height)
    //         .attr("fill", "#FFF")
    //         .attr("opacity", "80%")
    // }
    // labels(measure)
    // update_bbox(measure)
    // draw_rect(draw)
    labels(draw);
  }
}
class $2f416dba7774550a$var$LabelTransformer {
  constructor(styles, rotation_offset) {
    this.styles = styles;
    this.rotation_offset = rotation_offset;
    this.mid = this.mid.bind(this);
    this.rotate = this.rotate.bind(this);
    this.transform = this.transform.bind(this);
    this.x = this.x.bind(this);
    this.y = this.y.bind(this);
  }
  mid(d, i) {
    return d.startAngle - Math.PI / 2 + (d.endAngle - d.startAngle) / 2;
  }
  x(d, i) {
    return (
      Math.cos(this.mid(d)) * (this.styles.size / 2 - this.styles.margin / 2)
    );
  }
  y(d, i) {
    return (
      Math.sin(this.mid(d)) * (this.styles.size / 2 - this.styles.margin / 2)
    );
  }
  rotate(d, i, rotation_offset = 0) {
    const from = Math.PI / 8 + (-1 * rotation_offset * Math.PI) / 180;
    const to =
      (2 * Math.PI * (3 / 4)) / 2 + (-1 * rotation_offset * Math.PI) / 180;
    let base = (180 / Math.PI) * this.mid(d) + 90;
    if (this.mid(d) >= from) base += 180;
    if (this.mid(d) > to) base += 180;
    return base;
  }
  transform(d, i) {
    return `rotate(${this.rotate(d, i, this.rotation_offset)} ${this.x(d)} ${this.y(d)})`;
  }
}
class $2f416dba7774550a$var$InitiativeTransformer {
  constructor(
    options,
    timescale,
    bubble_scale,
    color_scale,
    sections,
    pie,
    rotation,
  ) {
    this.options = options;
    this.rotation = rotation;
    this.timescale = timescale;
    this.bubble_scale = bubble_scale;
    this.color_scale = color_scale;
    this.r = this.r.bind(this);
    this.x = this.x.bind(this);
    this.y = this.y.bind(this);
    this.r_planning = this.r_planning.bind(this);
    this.cy = this.cy.bind(this);
    this.fill = this.fill.bind(this);
    this.transform = this.transform.bind(this);
    this.sections = sections.sort((a, b) => b.weight - a.weight);
    this.section_ids = this.sections.map((s) => s.id);
    this.pie = pie(this.sections);
  }
  r_planning(initiative) {
    const start = this.timescale(new Date(initiative.start_date).getTime());
    const end = this.timescale(new Date(initiative.end_date).getTime());
    return ((end - start) / 2) * 0.5;
  }
  r(initiative) {
    let value = initiative[this.options.initiatives.bubbles.size_field];
    if (value == undefined) {
      const average =
        this.bubble_scale.domain().reduce((acc, num) => (acc += num)) /
        this.bubble_scale.domain().length;
      value = average;
    }
    return this.bubble_scale(value);
  }
  async x(initiative, index) {
    return (
      Math.sin(
        (await this.letter(initiative)) +
          (0, $fab42eb3dee39b5b$export$7460e682ce0f6da3)(this.rotation),
      ) *
      -1 *
      this.timescale(initiative.start_date)
    );
  }
  async y(initiative, index) {
    return (
      Math.cos(
        (await this.letter(initiative)) +
          (0, $fab42eb3dee39b5b$export$7460e682ce0f6da3)(this.rotation),
      ) * this.timescale(initiative.start_date)
    );
  }
  cy(initiative, index) {
    return this.timescale(initiative.start_date);
  }
  mid(d, i) {
    return d.startAngle - Math.PI / 2 + (d.endAngle - d.startAngle) / 2;
  }
  async letter(initiative) {
    let part_index = this.section_ids.indexOf(initiative.source);
    part_index = part_index == -1 ? 0 : part_index;
    const part = this.pie[part_index];
    const number_of_slices = this.options.sections.number_of_slices ?? 50;
    const index = await (0, $fab42eb3dee39b5b$export$354d673d2de74a14)(
      initiative.id,
      number_of_slices,
    );
    // bubbled that render to close to the next section are confusing. It is unclear in which
    // section they belong. So we keep the outsides ± 10% of a section clean of bubbles.
    // this means 10% on each side, so ± 20% of total section does not render bubbles.
    const margin = 0.1;
    const part_size =
      ((part.endAngle - part.startAngle) * (1 - 2 * margin)) / number_of_slices;
    return (
      part.startAngle -
      (part.startAngle - part.endAngle) * margin -
      Math.PI / 2 +
      (index + 0.5) * part_size
    );
  }
  fill(initiative) {
    let color_key = 'unknown';
    if (
      (0, $fab42eb3dee39b5b$export$3da0c1ee5c83c1d7)(
        this.options.initiatives.bubbles.color_field,
      )
    )
      color_key =
        (0, $fab42eb3dee39b5b$export$1dc1e50544972cf2)(
          initiative,
          this.options.initiatives.bubbles.color_field,
        ) ?? 'unknown';
    else
      color_key =
        initiative[this.options.initiatives.bubbles.color_field] ?? 'unknown';
    let color = this.color_scale(color_key);
    if (color == undefined) color = '#4b5563';
    return color;
  }
  async transform(initiative, index) {
    const rotation = (0, $fab42eb3dee39b5b$export$575567690b0feb0d)(
      await this.letter(initiative),
    );
    return `rotate(${rotation + this.rotation})`;
  }
}

export {
  $2f416dba7774550a$export$7608f99c51d98df2 as default_options,
  $2f416dba7774550a$export$172a5934950afa00 as default_styles,
  $2f416dba7774550a$export$bace472c466fdd25 as Radar,
};
